import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Text } from 'office-ui-fabric-react';
import { Link } from 'react-router-dom';
import './AddCustomer.scss';
import { IconButton, IIconProps, PrimaryButton, DefaultButton, Spinner, SpinnerSize, Link as HLink, MessageBar, MessageBarType } from '@fluentui/react';
import DataTable from 'react-data-table-component';
import { SearchMSXGrouped } from 'app/modules/user/createTicket/customerImpact/SearchMSXGrouped';
import { CustomerCard } from 'app/modules/user/createTicket/customerImpact/CustomerCard';
import { ISelectedData } from 'app/models/common/response';
import { DeviceModelDto, RequestDto, RequestType } from 'generated/request-backend';
import { usePostAddCustomer } from 'app/services/mutations';
import { usePostAddCustomerReviewRequest } from 'app/services/css-api';
import { usePostAddCustomerTechnicalRequest } from 'app/services/cxp-api';
import { CountryDto, CustomerImpactDto, IAddCustomerImpactDto, ICustomerImpactResponseDto, RequestDomain, UserDto, UserRole } from 'generated/cxp-backend';
import CustomerFamilyResult, { validateCustomerFamilyResult } from 'app/modules/user/addCustomerWizard/CustomerFamilyResult';
import { addCustomerSubmit, keyPress, searchedColumns } from 'app/components/helpers';
import { ChevronDownIcon } from '@fluentui/react-icons-mdl2';
import { useGetCustomersList } from 'app/services/search-api';
import { MsxSuggestDocument, MsxSuggestResponse } from 'generated/search-backend';
import _ from 'lodash';
import AddMultiDetails from './AddMultiDetails/AddMultiDetails';
import AddNewDetails from './AddNewDetails/AddNewDetails';
import SuccessPopup from './SuccessPopUp/SuccessPopup';
import { Trans, useTranslation } from 'react-i18next';
import AddProduct from 'app/modules/admin/detailsPanel/addProduct/AddProduct';
import useStore, { IStore } from 'app/store';
import { AppQueryClient } from 'app/services/clients/query-client';
import { useGetCountries } from 'app/services/request-api';
import { StringConstants, TelemetryConstants, appInsightsService } from 'app/utils/constants';
import { ICustomerResult, ISelectedCustomerImpact } from 'app/modules/user/createTicket/customerImpact/types';
import {
    buildImpactDescription,
    parseImpactDescription
} from 'app/modules/user/createTicket/customerImpact/customerImpactMapping';
import { SAME_ISSUE_DESCRIPTION } from 'app/modules/user/createTicket/customerImpact/impactDescriptionConstants';
import { IRemoveCustomerImpactData } from 'app/models/common/request';
import { useIsNewTicketViewEnabled } from 'app/modules/newTicketView/viewFlag';
import {
    endFlow,
    flowElapsedSeconds,
    isFlowEnded,
    logFlowEvent,
    startFlow
} from 'app/modules/user/createTicket/flowTelemetry';
import { ViewTelemetryConstants, VIEW_TELEMETRY_SECTION } from 'app/modules/newTicketView/telemetryConstants';
import { isValidCurrencyInput, isValidWholeNumberInput } from 'app/utils/currencyUtils';
import { isImpactReasonComplete } from './ImpactReasonFields';
import { CustomerImpactEditDto, CustomerImpactEditSnapshotDto } from 'generated/cxp-backend';
import {
    useCustomerImpactEditSnapshot,
    useReconcileCustomerImpactEdit,
    useSaveCustomerImpactEdit,
} from 'app/services/customer-impact-edit-api';
import { newRequestIdentity } from 'app/modules/user/createTicket/creationDraftIdentity';

interface ISearchProps {
    selectedRequest: RequestDto;
    globalSelectedRequest: RequestDto;
    onDismiss?: () => void;
    onSuccessHandler?: Function;
    setSelectedRequest: Function;
    requestProcessing: boolean;
    setRequestProcessing: (requestProcessing: boolean) => void;
    displayScreen: string;
    setDisplayScreen: (displayScreen: string) => void;
    /**
     * When provided (kebab "Edit"), seeds the impact form with the selected
     * customer and jumps straight to the "Add Details" step (Step 2).
     */
    initialCustomer?: IRemoveCustomerImpactData;
    onEditSuccess?: () => void;
}

interface IEditableCustomerData extends ISelectedData {
    id?: number;
    status?: string;
    requestType?: RequestType;
    region?: string;
    city?: string;
    postalCode?: string;
}

const hasValidRevenue = (value?: number | string) => {
    const text = String(value ?? '').trim();
    return text !== '' && isValidCurrencyInput(text);
};

const hasValidDeviceCount = (value?: number | string) => {
    const text = String(value ?? '').replaceAll(',', '').trim();
    return text !== '' && isValidWholeNumberInput(text);
};

const editInputState = (item: IEditableCustomerData | undefined, cssNumber: string) => JSON.stringify([
    String(item?.estimatedValue ?? '').trim() === '' ? null : Number(String(item?.estimatedValue).replace(/[$,]/g, '')),
    String(item?.totalDeviceCount ?? '').trim() === '' ? null : Number(String(item?.totalDeviceCount).replace(/,/g, '')),
    item?.customerImpact, item?.importanceReason, item?.importanceOtherText, item?.sameIssue,
    item?.entireDealDepends, item?.accountName, item?.id, item?.country, cssNumber
]);

const AddCustomer: React.FC<ISearchProps> = (props) => {
    const { t } = useTranslation();
    const {
        selectedRequest,
        onDismiss,
        onSuccessHandler,
        globalSelectedRequest,
        setSelectedRequest,
        displayScreen = 'searchCust',
        setDisplayScreen,
        requestProcessing,
        setRequestProcessing,
        initialCustomer,
        onEditSuccess
    } = props;

    const cancelIcon: IIconProps = { iconName: StringConstants.CANCEL };
    const { data: countryList } = useGetCountries();
    const userDetails: UserDto = useStore((state: IStore) => state.userDetails as UserDto);
    const [toggleTable, setToggleTable] = React.useState(false);
    const [customerHelperText] = useState(false);
    const [newCountryHelperText] = useState(false);
    const [, setSearchField] = useState('');
    const [searchedCustomer, setSearchedCustomer] = useState<MsxSuggestDocument[]>([]);
    const [manualData, setManualData] = useState(false);
    const [estimatedValue, setEstimatedValue] = useState('');
    const [matchFound, setMatchFound] = useState(false);
    const [selectedData, setSelectedData] = useState<IEditableCustomerData[]>([]);
    const [searchedMSX] = useState('');
    const [successData, setSuccessData] = useState({ customer_name: '', country: '', impacted_revenue: '', skpIdPost: '' });
    const [, setSuggestionSelected] = useState(false);
    const [selectedAccountId, setSelectedAccountId] = useState('');
    const [errorCustomerName, setErrorCustomerName] = useState(false);
    const [errorCountry, setErrorCountry] = useState(false);
    const [errorEstimatedValue, setErrorEstimatedValue] = useState(false);
    const [errorTotalDeviceCount, setErrorTotalDeviceCount] = useState(false);
    const [noDetailsFound, setNoDetailsFound] = useState(false);
    const [originalSelected, setOriginalSelected] = useState([]);
    const [multiFormError, setMultiFormError] = useState(false);
    const [cssNumber, setCssNumber] = useState<string>(selectedRequest.cssCaseNumber ?? '');
    const [cssNumberText, setCssNumberText] = useState(false);
    const [isAddNewDetails, setIsAddNewDetails] = useState(false);
    const [addedDevices, setAddedDevices] = useState<DeviceModelDto[]>([]);
    const isNewTicketViewEnabled = useIsNewTicketViewEnabled();
    const activeScreenRef = useRef(displayScreen);
    const [familyResult, setFamilyResult] = useState<ICustomerImpactResponseDto>();
    const hasSuccessHandler = Boolean(onSuccessHandler);
    const [editSnapshot, setEditSnapshot] = useState<CustomerImpactEditSnapshotDto>();
    const [editError, setEditError] = useState('');
    const editPending = useRef(false);
    const editBusy = useRef(false);
    const editSession = useRef(0);
    const seededEdit = useRef<IEditableCustomerData>();
    const currentEditInputs = useRef('');
    currentEditInputs.current = editInputState(selectedData[0], cssNumber);
    const acknowledgedEditInputs = useRef<string>();
    const [editRequiresReload, setEditRequiresReload] = useState(false);
    const addSubmissionId = useRef(newRequestIdentity());
    const editSelector = React.useMemo(() => initialCustomer
        ? CustomerImpactDto.fromJS(JSON.parse(JSON.stringify(initialCustomer)))
        : undefined, [initialCustomer]);
    const editSnapshotQuery = useCustomerImpactEditSnapshot(selectedRequest, editSelector);
    const saveEdit = useSaveCustomerImpactEdit();
    const reconcileEdit = useReconcileCustomerImpactEdit();

    const showFamilyResult = useCallback((response: ICustomerImpactResponseDto | undefined): boolean => {
        if (hasSuccessHandler || !response?.outcomes?.length) return false;
        try {
            setFamilyResult(validateCustomerFamilyResult(response));
            setDisplayScreen('familyResults');
            setRequestProcessing(false);
            logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_SUCCEEDED, 'Add Customer', {
                requestType: selectedRequest.requestType,
                createdChildCount: response.outcomes.filter(outcome => outcome.action === 'Created').length,
                updatedChildCount: response.outcomes.filter(outcome => outcome.action === 'Updated').length,
                parentCreated: !!response.parentCreated,
                parentReused: !!response.parentRequestId && !response.parentCreated,
                associationResult: response.parentRequestId ? 'succeeded' : 'notNeeded',
                totalDuration: flowElapsedSeconds(),
            });
            endFlow();
        } catch {
            setRequestProcessing(false);
            setDisplayScreen('errorPopUp');
            logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_FAILED, 'Add Customer', { reason: 'invalid-family-result' });
        }
        return true;
    }, [hasSuccessHandler, selectedRequest.requestType]);

    useEffect(() => {
        activeScreenRef.current = displayScreen;
    }, [displayScreen]);

    useEffect(() => {
        if (!isNewTicketViewEnabled) {
            return;
        }
        startFlow('addCustomer');
        logFlowEvent(TelemetryConstants.FLOW_STARTED, 'Add Customer', {
            entrySource: initialCustomer ? 'editCustomer' : 'ticketDetail'
        });
        logFlowEvent(TelemetryConstants.ADD_CUSTOMER_STARTED, 'Add Customer', {
            isEdit: !!initialCustomer
        });
        logFlowEvent(ViewTelemetryConstants.ADD_CUSTOMER_DRAWER_OPENED, VIEW_TELEMETRY_SECTION, {
            entrySource: initialCustomer ? 'editCustomer' : 'ticketDetail',
            isEdit: !!initialCustomer
        });
        return () => {
            if (!isFlowEnded()) {
                logFlowEvent(TelemetryConstants.FLOW_ABANDONED, 'Add Customer', {
                    lastScreen: activeScreenRef.current,
                    totalDuration: flowElapsedSeconds()
                });
            }
        };
        // Start only after the asynchronously resolved feature flag activates this view.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isNewTicketViewEnabled]);

    const dismissHandler = () => {
        if (isNewTicketViewEnabled && !isFlowEnded()) {
            logFlowEvent(TelemetryConstants.CUSTOMER_IMPACT_PANEL_CANCELLED, 'Add Customer', {
                screen: displayScreen,
                selectedCount: selectedData.length,
                totalDuration: flowElapsedSeconds()
            });
            endFlow();
        }
        onDismiss();
    };

    /**
     * Edit flow: when a customer is passed in, reverse-map the persisted
     * CustomerImpactDto back into the ISelectedData form shape and jump to the
     * "Add Details" step so the fields render pre-filled.
     */
    useEffect(() => {
        const session = ++editSession.current;
        setEditSnapshot(undefined);
        setEditError('');
        editPending.current = false;
        acknowledgedEditInputs.current = undefined;
        setEditRequiresReload(false);
        if (!initialCustomer) return;
        if (editSnapshotQuery.isLoading || editSnapshotQuery.isFetching) return;
        if (editSnapshotQuery.isError || !editSnapshotQuery.data) {
            setEditError('This customer could not be loaded uniquely. Reload the ticket before editing.');
            logFlowEvent('CustomerImpactEditRejected', 'Edit Customer', { stage: 'snapshot' });
            return;
        }
        const snapshot = editSnapshotQuery.data;
        const persistedImpact = snapshot.impact;
        const parsedDescription = parseImpactDescription(persistedImpact.customerImpactDescription);
        const seeded: IEditableCustomerData = {
            revenueErrorText: false,
            devicesErrorText: false,
            accountName: persistedImpact.customerName,
            accountNumber: persistedImpact.accountId,
            id: persistedImpact.customerCountry?.id,
            country: persistedImpact.customerCountry?.name,
            opportunityNumber: persistedImpact.opportunityId,
            opportunityId: persistedImpact.msxOpportunityId,
            estimatedValue:
                persistedImpact.revenue ?? persistedImpact.msxRevenue,
            totalDeviceCount:
                persistedImpact.deviceCount ?? persistedImpact.msxDeviceCount,
            estimatedRevenue: persistedImpact.msxRevenue,
            estimatedDevices: persistedImpact.msxDeviceCount,
            customerImpact: parsedDescription.customerImpact,
            customerImpactDescription: persistedImpact.customerImpactDescription,
            importanceReason: parsedDescription.importanceReason,
            importanceOtherText: parsedDescription.importanceOtherText,
            sameIssue: snapshot.isSameAsTicket ?? parsedDescription.sameIssue,
            entireDealDepends: parsedDescription.entireDealDepends,
            topic: parsedDescription.topic,
            legacyOpportunityTail: parsedDescription.legacyOpportunityTail,
            status: persistedImpact.status,
            tPID: persistedImpact.tpId,
            region: persistedImpact.state,
            city: persistedImpact.city,
            postalCode: persistedImpact.zipCode
        };
        setEditSnapshot(snapshot);
        seededEdit.current = seeded;
        setSelectedData([seeded]);
        // originalSelected is the MSX baseline the submit mapper diffs against to
        // decide seller-attested vs. MSX revenue/devices. Seed it with the MSX
        // figures (not the attested display values) so an unchanged edit keeps the
        // existing seller-attested override instead of zeroing it and rewriting it
        // into the MSX fields.
        setOriginalSelected([
            {
                ...seeded,
                estimatedValue: persistedImpact.msxRevenue,
                totalDeviceCount: persistedImpact.msxDeviceCount
            }
        ]);
        setCssNumber(persistedImpact.cssCaseNumber ?? '');
        setDisplayScreen(!persistedImpact.accountId && !persistedImpact.opportunityId ? 'addNewDetails' : 'addMultiDetails');
        return () => { if (editSession.current === session) ++editSession.current; };
        // The owner snapshot belongs to this exact ticket and selected card, not to refreshed object instances.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialCustomer, selectedRequest.unifiedTrackingId, editSnapshotQuery.data,
        editSnapshotQuery.isError, editSnapshotQuery.isFetching, editSnapshotQuery.isLoading]);

    useEffect(() => {
        if (!initialCustomer) setCssNumber(selectedRequest.cssCaseNumber ?? '');
    }, [initialCustomer, selectedRequest.cssCaseNumber]);

    const rowDisabledCriteria = (row: MsxSuggestDocument) => {
        return selectedAccountId && row.accountNumber !== selectedAccountId;
    };

    const handleSelect = (state: { selectedCount: number; selectedRows: Array<MsxSuggestDocument | ISelectedData> }) => {
        const { selectedCount, selectedRows } : { selectedCount: number; selectedRows: Array<MsxSuggestDocument | ISelectedData> } = state;
        if (selectedCount === 0) {
            setSelectedAccountId('');
        }
        if (selectedCount === 1) {
            setSelectedAccountId(selectedRows[0]?.accountNumber);
        }
        if (selectedCount > 0) {
            const arr: ISelectedData[] = [];

            setOriginalSelected(selectedRows);

            (selectedRows as ISelectedData[]).forEach((item: ISelectedData) => {
                arr.push({ ...item, revenueErrorText: false, devicesErrorText: false });
            });
            setSelectedData(arr);
        } else {
            setSelectedData([]);
        }
    };

    const toggledClearRows = false;
    const {
        data: getCustomersListData,
        isSuccess: isSuccessGetCustomersListData,
        isLoading: isLoadingCustomerList
    } = useGetCustomersList();

    const {
        mutate: postAddCustomer,
        isSuccess: successPostAddCustomer,
        isError: errorPostAddCustomer,
        isLoading: isPostAddCustomer,
        data: postAddCustomerResponse
    } = usePostAddCustomer();

    const {
        mutate: postAddCustomerRR,
        isSuccess: successPostAddCustomerRR,
        isError: errorPostAddCustomerRR,
        isLoading: isPostAddCustomerRR,
        data: postAddCustomerResponseRR
    } = usePostAddCustomerReviewRequest();

    const {
        mutate: postAddCustomerTR,
        isSuccess: successPostAddCustomerTR,
        isError: errorPostAddCustomerTR,
        isLoading: isPostAddCustomerTR,
        data: postAddCustomerResponseTR
    } = usePostAddCustomerTechnicalRequest();

    const getValidatedImpactDescriptions = (): string[] | null => {
        const impactDescriptions = selectedData.map(buildImpactDescription);
        const blankImpactIndexes = impactDescriptions.reduce<number[]>(
            (indexes, description, index) => description.trim() ? indexes : [...indexes, index],
            []
        );
        if (blankImpactIndexes.length === 0) {
            return impactDescriptions;
        }

        setMultiFormError(true);
        setRequestProcessing(false);
        if (initialCustomer) {
            logFlowEvent('CustomerImpactEditRejected', 'Edit Customer', {
                stage: 'validation', reason: 'customer-impact-description-empty'
            });
        } else {
            logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_FAILED, 'Add Customer', {
                reason: 'customer-impact-description-empty',
                requestId: selectedRequest?.unifiedTrackingId,
                impactCount: selectedData.length,
                blankImpactCount: blankImpactIndexes.length,
                blankImpactIndexes: blankImpactIndexes.join(',')
            });
        }
        return null;
    };

    const handleAddCustomer = () => {
        if (initialCustomer) {
            void submitEditCustomer();
            return;
        }
        setErrorCustomerName(false);
        setErrorCountry(false);
        setErrorEstimatedValue(false);
        setErrorTotalDeviceCount(false);
        setCssNumberText(false);
        setMultiFormError(false);

        if (!selectedData[0] || !selectedData[0]?.accountName) {
            setErrorCustomerName(true);
        }
        if (
            selectedRequest.requestType === RequestType.CssReviewRequest ||
            selectedRequest.requestType === RequestType.CXP_TechnicalRequest
        ) {
            if (!cssNumber || cssNumber === '') {
                setCssNumberText(true);
            }
        }
        if (!selectedData[0] || !selectedData[0].country) {
            setErrorCountry(true);
        }

        if (!selectedData[0] || !hasValidRevenue(selectedData[0].estimatedValue)) {
            setErrorEstimatedValue(true);
        }

        if (!selectedData[0] || !hasValidDeviceCount(selectedData[0].totalDeviceCount)) {
            setErrorTotalDeviceCount(true);
        }

        let errorFlag = false;
        selectedData.every((ele) => {
            if (
                !ele?.accountName?.trim() ||
                ele?.accountName?.trim() === '' ||
                !ele?.country?.trim() ||
                ele?.country?.trim() === '' ||
                !hasValidRevenue(ele?.estimatedValue) ||
                !hasValidDeviceCount(ele?.totalDeviceCount) ||
                (isNewTicketViewEnabled && !isImpactReasonComplete(ele)) ||
                !ele?.customerImpact?.trim() ||
                ((selectedRequest.requestType === RequestType.CssReviewRequest ||
                    selectedRequest.requestType === RequestType.CXP_TechnicalRequest) &&
                    !cssNumber?.trim())
            ) {
                errorFlag = true;
                return false;
            } else {
                return true;
            }
        });
        if (selectedData.length === 0) {
            setErrorEstimatedValue(true);
            setErrorCustomerName(true);
            setErrorCountry(true);
            errorFlag = true;
        }

        if (errorFlag) {
            let tempArray: ISelectedData[] = [];

            selectedData.forEach((ele) => {
                let updatedValue = { ...ele };
                if (!ele?.accountName?.trim() || ele?.accountName?.trim() === '') {
                    setErrorCustomerName(true);
                }
                if (!ele?.country?.trim() || ele?.country?.trim() === '') {
                    setErrorCountry(true);
                }
                if (!hasValidRevenue(ele?.estimatedValue)) {
                    if (displayScreen === StringConstants.CAMELCASE_ADD_NEW_DETAILS) {
                    } else {
                        updatedValue.revenueErrorText = true;
                    }
                }
                if (!hasValidDeviceCount(ele?.totalDeviceCount)) {
                    if (displayScreen === StringConstants.CAMELCASE_ADD_NEW_DETAILS) {
                    } else {
                        updatedValue.devicesErrorText = true;
                    }
                }
                tempArray.push(updatedValue);
            });
            setSelectedData(tempArray);
            return;
        }

        if (!getValidatedImpactDescriptions()) {
            return;
        }

        if (isNewTicketViewEnabled) {
            logFlowEvent(TelemetryConstants.SUBMIT_CLICKED, 'Add Customer', {
                customerCount: selectedData.length,
                totalDuration: flowElapsedSeconds()
            });
            setRequestProcessing(true);
            if (submitAddCustomer()) {
                setDisplayScreen('');
            }
            return;
        }
        setDisplayScreen('updateProducts');
    };

    const [addedCustomerImpacts, setAddedCustomerImpacts] = useState<CustomerImpactDto[]>([]);

    const submitEditCustomer = async () => {
        if (!editSnapshot || editBusy.current) return;
        if (editRequiresReload) {
            setEditError('Your newer edits are retained but not saved. Reload this ticket before saving them.');
            return;
        }
        const item = selectedData[0];
        if (item && item.accountName !== seededEdit.current?.accountName && !item.accountName?.trim()) {
            setEditError('Please enter a customer name before saving.');
            return;
        }
        if (!item || !hasValidRevenue(item.estimatedValue) || !hasValidDeviceCount(item.totalDeviceCount)
            || !item.customerImpact?.trim()) {
            setEditError('Please complete the customer impact fields before saving.');
            return;
        }
        const cssVisible = [RequestType.CSSRequest, RequestType.CssReviewRequest, RequestType.CXP_TechnicalRequest]
            .includes(selectedRequest.requestType);
        if (cssVisible && !cssNumber.trim()) {
            setEditError('CSS case number is required for this request type.');
            return;
        }
        const descriptions = getValidatedImpactDescriptions();
        if (!descriptions) return;
        const session = editSession.current;
        const attemptedInputs = currentEditInputs.current;
        editBusy.current = true;
        setRequestProcessing(true);
        setEditError('');
        try {
            if (editPending.current) {
                await reconcileEdit.mutateAsync(selectedRequest);
            } else {
                const original = editSnapshot.impact;
                const seed = seededEdit.current;
                const descriptionUnchanged = ['customerImpact', 'importanceReason', 'importanceOtherText',
                    'sameIssue', 'entireDealDepends'].every(key => item[key as keyof IEditableCustomerData] === seed[key as keyof IEditableCustomerData]);
                const result = await saveEdit.mutateAsync({ request: selectedRequest, edit: new CustomerImpactEditDto({
                    version: editSnapshot.version,
                    originalFingerprint: editSnapshot.originalFingerprint,
                    revenue: String(item.estimatedValue) === String(seed.estimatedValue) ? original.revenue
                        : Number(String(item.estimatedValue).replace(/[$,]/g, '')),
                    deviceCount: String(item.totalDeviceCount) === String(seed.totalDeviceCount) ? original.deviceCount
                        : Number(String(item.totalDeviceCount).replace(/,/g, '')),
                    customerImpactDescription: descriptionUnchanged ? original.customerImpactDescription : descriptions[0],
                    isSameAsTicket: item.sameIssue === seed.sameIssue && item.customerImpact === seed.customerImpact
                        ? editSnapshot.isSameAsTicket : !!item.sameIssue,
                    cssCaseNumber: cssVisible ? cssNumber : undefined,
                    customerName: item.accountName === seed.accountName ? undefined : item.accountName,
                    customerCountry: item.id === seed.id && item.country === seed.country ? undefined
                        : new CountryDto({ id: item.id, name: item.country })
                }) });
                if (editSession.current !== session) return;
                acknowledgedEditInputs.current = attemptedInputs;
                editPending.current = result.synchronized !== true;
                if (editPending.current) {
                    setEditError(result.message || 'Saved, but synchronization is pending. Retry synchronization; do not add another customer.');
                    return;
                }
            }
            if (editSession.current !== session) return;
            editPending.current = false;
            AppQueryClient.invalidateQueries('getRequestById');
            AppQueryClient.invalidateQueries('listBuilder');
            if (currentEditInputs.current !== acknowledgedEditInputs.current) {
                setEditRequiresReload(true);
                setEditError('Synchronization is complete, but newer edits have not been saved. Your inputs are retained. Reload this ticket before saving them.');
                logFlowEvent('CustomerImpactEditSynchronizationCompleted', 'Edit Customer', { additionalEditsPending: true });
                return;
            }
            logFlowEvent('CustomerImpactEditSucceeded', 'Edit Customer', { synchronized: true });
            (onEditSuccess || onDismiss)?.();
        } catch {
            if (editSession.current === session) {
                setEditError('Save could not be confirmed. Your edits are retained. Reload to check the ticket before retrying; never use Add for this edit.');
                logFlowEvent('CustomerImpactEditRejected', 'Edit Customer', { stage: editPending.current ? 'synchronization' : 'save' });
            }
        } finally {
            editBusy.current = false;
            if (editSession.current === session) setRequestProcessing(false);
        }
    };

    const submitAddCustomer = () => {
        const impactDescriptions = getValidatedImpactDescriptions();
        if (!impactDescriptions) {
            return false;
        }

        let subUrl = addCustomerSubmit({
            team: selectedRequest?.requestTeam,
            requestType: selectedRequest?.requestType,
            skpId: selectedRequest?.unifiedTrackingId
        });
        if (
            selectedRequest.requestType === RequestType.CssReviewRequest ||
            selectedRequest.requestType === RequestType.CXP_TechnicalRequest
        ) {
            let dataPass : IAddCustomerImpactDto = {
                requestId: selectedRequest.unifiedTrackingId,
                submissionId: addSubmissionId.current,
                cssCaseNumber: cssNumber,
                customerImpacts: selectedData.map((item, index) => (new CustomerImpactDto({
                    ...item,
                    opportunityId: item.opportunityNumber,
                    msxOpportunityId: item.opportunityId,
                    accountId: item.accountNumber,
                    customerName: item.accountName,
                    customerImpactDescription: impactDescriptions[index],
                    isSameAsTicket: !!item.sameIssue,
                    status: item.status,
                    customerCountry: new CountryDto({
                        id: item.id,
                        name: item.country
                    }),
                    deviceCount:
                        parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')) ===
                        parseInt(
                            originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.totalDeviceCount
                        )
                            ? 0
                            : parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')),
                    revenue:
                        parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')) ===
                        parseFloat(
                            originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                        )
                            ? 0
                            : parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')),
                    msxDeviceCount: isAddNewDetails
                        ? 0
                        : parseInt(
                              originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]
                                  ?.totalDeviceCount
                          ),
                    msxRevenue: isAddNewDetails
                        ? 0
                        : parseFloat(
                              originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                          ),
                    addedOn: new Date(),
                    addedBy: new UserDto({
                        id: userDetails.id,
                        displayName: userDetails.displayName,
                        email: userDetails.email,
                        userDomain: userDetails.userDomain as unknown as RequestDomain,
                        userRoles: userDetails.userRoles as UserRole[]
                    }),
                    endCustomerSegment: '',
                    competitor: '',
                    salesPlay: '',
                    refreshYourDevice: ''
                }))),
                deviceModels: globalSelectedRequest.deviceModels
            };
            if (!manualData) {
                let impacts = dataPass.customerImpacts;
                let res: CustomerImpactDto[] = [];
                impacts.forEach((item, index) => {
                    let temp = new CustomerImpactDto({
                        ...item,
                        state: selectedData[index]?.region,
                        city: selectedData[index]?.city,
                        zipCode: selectedData[index]?.postalCode
                    });
                    res.push(temp);
                });
                dataPass = { ...dataPass, customerImpacts: res };
            }
            setAddedCustomerImpacts(dataPass.customerImpacts);
            setSelectedRequest({ ...globalSelectedRequest, updatedCustCssNum: cssNumber });
            if (selectedRequest.requestType === RequestType.CssReviewRequest) {
                postAddCustomerRR({ ...dataPass });
            } else {
                postAddCustomerTR({ ...dataPass });
            }
        } else {
            let dataPass : IAddCustomerImpactDto = {
                requestId: selectedRequest.unifiedTrackingId,
                submissionId: addSubmissionId.current,
                cssCaseNumber: cssNumber,
                customerImpacts: selectedData.map((item, index) => (new CustomerImpactDto({
                    ...item,
                    opportunityId: item.opportunityNumber,
                    tpId: item.tPID,
                    msxOpportunityId: item.opportunityId,
                    accountId: item.accountNumber,
                    customerName: item.accountName,
                    customerImpactDescription: impactDescriptions[index],
                    isSameAsTicket: !!item.sameIssue,
                    customerCountry: new CountryDto({
                        name: item.country
                    }),
                    deviceCount:
                        parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')) ===
                        parseInt(
                            originalSelected?.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.totalDeviceCount
                        )
                            ? 0
                            : parseInt(item.totalDeviceCount?.toString().replaceAll(',', '')),
                    revenue:
                        parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')) ===
                        parseFloat(
                            originalSelected?.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                        )
                            ? 0
                            : parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')),
                    msxDeviceCount: isAddNewDetails
                    ? 0
                    : parseInt(
                              originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]
                                  ?.totalDeviceCount
                          ),
                    msxRevenue: isAddNewDetails
                        ? 0
                        : parseFloat(
                            originalSelected.filter((ele) => ele.opportunityNumber === item.opportunityNumber)[0]?.estimatedValue
                          )
                }))),
                deviceModels: globalSelectedRequest.deviceModels
            };
            if (!manualData) {
                let impacts = dataPass.customerImpacts;
                let res: CustomerImpactDto[] = [];
                impacts.forEach((item, index) => {
                    if (item.msxDeviceCount === item.deviceCount) {
                        item.deviceCount = null;
                    }
                    if (item.msxRevenue === item.revenue) {
                        item.revenue = null;
                    }
                    let temp = new CustomerImpactDto({
                        ...item,
                        state: selectedData[index]?.region,
                        city: selectedData[index]?.city,
                        zipCode: selectedData[index]?.postalCode
                    });
                    res.push(temp);
                });
                dataPass = { ...dataPass, customerImpacts: res };
            }
            setAddedCustomerImpacts(dataPass.customerImpacts);
            postAddCustomer({ subUrl: subUrl, data: dataPass });
        }
        appInsightsService.logRequestflowTelemetry(TelemetryConstants.DEFLECTION_DECISION, "add_existing_customer", {
            source: 'ticketDetail',
        });
        return true;
    };

    const handleMultiChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, type: string, id: string) => {
        setMultiFormError(false);
        let updateValue = selectedData.map((item) => ({ ...item }));

        updateValue = updateValue.map((item) => {
            if (item.opportunityNumber === id) {
                switch (type) {
                    case 'impacted_revenue':
                        item.estimatedValue = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        item.revenueErrorText = false;
                        break;
                    case 'impacted_device':
                        item.totalDeviceCount = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        item.devicesErrorText = false;
                        break;
                    case 'accountNumber':
                        item.accountNumber = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'accountName':
                        item.accountName = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'country':
                        item.country = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'customer_impact':
                        item.customerImpact = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        item.sameIssue = item.customerImpact === SAME_ISSUE_DESCRIPTION;
                        break;
                    case 'importance_reason':
                        item.importanceReason = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        appInsightsService.logRequestflowTelemetry(TelemetryConstants.IMPACT_REASON_SELECTED, "add_existing_customer", {
                            reason: (e.target as HTMLInputElement | HTMLTextAreaElement).value,
                        });
                        break;
                    case 'importance_other':
                        item.importanceOtherText = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                        break;
                    case 'same_issue':
                        item.sameIssue = (e.target as HTMLInputElement | HTMLTextAreaElement).value === 'true';
                        break;
                    case 'entire_deal':
                        item.entireDealDepends = (e.target as HTMLInputElement | HTMLTextAreaElement).value === 'true';
                        break;
                    case 'css-case-num':
                        setCssNumber((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                        break;
                    default:
                        break;
                }
            }
            return item;
        });
        setSelectedData(updateValue);
    };

    const handleMultiChanges = (id: string, changes: Partial<IEditableCustomerData>) => {
        setMultiFormError(false);
        setSelectedData((currentData) =>
            currentData.map((item) =>
                item.opportunityNumber === id
                    ? { ...item, ...changes }
                    : item
            )
        );
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, type: string) => {
        setMultiFormError(false);
        let updateValue = initialCustomer
            ? selectedData.map(item => ({ ...item }))
            : selectedData.slice(0);
        if (updateValue.length === 0) {
            updateValue = [{ revenueErrorText: false, devicesErrorText: false }];
        }

        if (updateValue.length !== 0) {
            switch (type) {
                case 'impacted_revenue':
                    updateValue[0]['estimatedValue'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorEstimatedValue(false);
                    break;
                case 'impacted_device':
                    updateValue[0]['totalDeviceCount'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorTotalDeviceCount(false);
                    break;
                case 'accountNumber':
                    updateValue[0]['accountNumber'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    break;
                case 'accountName':
                    updateValue[0]['accountName'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorCustomerName(false);
                    break;
                case 'country':
                    updateValue[0]['country'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    setErrorCountry(false);
                    break;
                case 'importance_reason':
                    updateValue[0]['importanceReason'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    appInsightsService.logRequestflowTelemetry(TelemetryConstants.IMPACT_REASON_SELECTED, "add_new_customer", {
                        reason: (e.target as HTMLInputElement | HTMLTextAreaElement).value,
                    });
                    break;
                case 'importance_other':
                    updateValue[0]['importanceOtherText'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    break;
                case 'same_issue':
                    updateValue[0]['sameIssue'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value === 'true';
                    break;
                case 'customer_impact':
                    updateValue[0]['customerImpact'] = (e.target as HTMLInputElement | HTMLTextAreaElement).value;
                    updateValue[0]['sameIssue'] = updateValue[0]['customerImpact'] === SAME_ISSUE_DESCRIPTION;
                    break;
                case 'css-case-num':
                    setCssNumber((e.target as HTMLInputElement | HTMLTextAreaElement).value);
                    setCssNumberText(false);
                    break;
                default:
                    break;
            }
        }
        setSelectedData(updateValue);
    };

    const handleChanges = (changes: Partial<IEditableCustomerData>) => {
        setMultiFormError(false);
        setSelectedData((currentData) => {
            const nextData = currentData.length > 0
                ? currentData
                : [{ revenueErrorText: false, devicesErrorText: false }];
            return [{ ...nextData[0], ...changes }, ...nextData.slice(1)];
        });
    };

    // Grouped MSX search (unified dropdown) selection handlers. These translate a
    // grouped result into the legacy selectedData/originalSelected shape the append
    // submit already understands, so the downstream Proceed -> details -> submit
    // path is preserved unchanged.
    const handleGroupedOpportunitySelect = (opportunity: MsxSuggestDocument) => {
        const seeded: IEditableCustomerData = {
            revenueErrorText: false,
            devicesErrorText: false,
            accountName: opportunity.accountName,
            country: opportunity.country,
            opportunityNumber: opportunity.opportunityNumber,
            opportunityId: opportunity.opportunityId,
            topic: opportunity.topic,
            estimatedValue: '',
            totalDeviceCount: '',
            estimatedRevenue: opportunity.estimatedValue,
            estimatedDevices: opportunity.totalDeviceCount,
        };
        setManualData(false);
        setIsAddNewDetails(false);
        setOriginalSelected((current) => {
            const exists = current.some((item) => item.opportunityNumber === seeded.opportunityNumber);
            return exists
                ? current
                : [
                    ...current,
                    {
                        ...seeded,
                        estimatedValue: opportunity.estimatedValue,
                        totalDeviceCount: opportunity.totalDeviceCount
                    }
                ];
        });
        setSelectedData((current) => {
            const exists = current.some((item) => item.opportunityNumber === seeded.opportunityNumber);
            return exists ? current : [...current, seeded];
        });
        setSuggestionSelected(true);
        logFlowEvent(TelemetryConstants.CUSTOMER_OPPORTUNITY_SELECTED, 'Add Customer', {
            resultType: 'opportunity'
        });
    };

    // A customer (account-level) result has no opportunity to attach, so route it
    // through the manual details screen with name/country pre-filled, mirroring the
    // existing "Can't find customer" manual path.
    const handleGroupedCustomerSelect = (customer: ICustomerResult) => {
        setManualData(true);
        setIsAddNewDetails(true);
        setOriginalSelected([]);
        setSelectedData([
            {
                revenueErrorText: false,
                devicesErrorText: false,
                accountName: customer.AccountName,
                country: customer.Country,
            },
        ]);
        setDisplayScreen(StringConstants.CAMELCASE_ADD_NEW_DETAILS);
        logFlowEvent(TelemetryConstants.CUSTOMER_CUSTOMER_SELECTED, 'Add Customer', {
            resultType: 'customer'
        });
    };

    const handleGroupedAddNewCustomer = () => {
        setManualData(true);
        setIsAddNewDetails(true);
        setSelectedData([]);
        setOriginalSelected([]);
        setDisplayScreen(StringConstants.CAMELCASE_ADD_NEW_DETAILS);
        logFlowEvent(TelemetryConstants.CUSTOMER_MANUAL_ENTRY_STARTED, 'Add Customer');
    };

    // Present the selected opportunity/customer below the search box as summary
    // cards, reusing the create-ticket CustomerCard so the drawer matches the new
    // flow. The impact numbers come from the MSX baseline captured at selection.
    const mapSelectedToImpact = (item: IEditableCustomerData): ISelectedCustomerImpact => {
        const revenue = parseFloat(String(item?.estimatedRevenue ?? '').replace(/[$,]/g, ''));
        const devices = parseFloat(String(item?.estimatedDevices ?? '').replace(/[$,]/g, ''));
        return {
            type: 'opportunity',
            accountName: item?.accountName,
            country: item?.country,
            msxOpportunityId: item?.opportunityNumber,
            topic: item?.topic,
            estimatedRevenue: Number.isFinite(revenue) ? revenue : undefined,
            estimatedDevices: Number.isFinite(devices) ? devices : undefined,
        } as ISelectedCustomerImpact;
    };

    const handleRemoveSelected = (index: number) => {
        const next = selectedData.filter((_, i) => i !== index);
        setSelectedData(next);
        setOriginalSelected(next);
        if (next.length === 0) {
            setSuggestionSelected(false);
        }
        logFlowEvent(TelemetryConstants.CUSTOMER_ITEM_REMOVED, 'Add Customer', {
            remainingCount: next.length
        });
    };

    useEffect(() => {
        setDisplayScreen('searchCust');
    }, []);

    useEffect(() => {
        if (selectedData) {
            let totalEstimatedValue = 0;

            selectedData.map(
                (item) =>
                    (totalEstimatedValue =
                        totalEstimatedValue + parseFloat(item.estimatedValue?.toString().replace('$', '').replaceAll(',', '')))
            );

            setEstimatedValue(totalEstimatedValue.toString());
        }
    }, [selectedData]);

    useEffect(() => {
        if (isSuccessGetCustomersListData) {
            let searchData: Array<MsxSuggestDocument> = [];
            searchData = getCustomersListData?.filter(
                    (item: MsxSuggestResponse) =>
                        !_.find(selectedRequest.customerImpacts, (obj) => {
                            if (initialCustomer && !editSnapshot) {
                                return editError ? <MessageBar messageBarType={MessageBarType.error}>{t(editError)}</MessageBar>
                                    : <Spinner label={t('Loading customer for editing...')} />;
                            }

                            return (
                                item.document.accountNumber === obj.accountId &&
                                item.document.opportunityNumber === obj.opportunityId
                            );
                        })
                )
                .map((item: MsxSuggestResponse) => {
                    const {
                        document: {
                            accountName,
                            tpid,
                            country,
                            opportunityNumber,
                            opportunityId,
                            topic,
                            estimatedValue,
                            totalDeviceCount,
                            accountNumber,
                            region,
                            city,
                            postalCode,
                            status
                        }
                    } = item;
                    return new MsxSuggestDocument({
                        accountName,
                        tpid,
                        country,
                        opportunityNumber,
                        opportunityId,
                        topic,
                        estimatedValue,
                        totalDeviceCount,
                        accountNumber,
                        region,
                        city,
                        postalCode,
                        status
                    });
                });
            if (searchData?.length === 0) {
                setNoDetailsFound(true);
            } else {
                setNoDetailsFound(false);
            }
            setSearchedCustomer(searchData);
            appInsightsService.logRequestflowTelemetry(TelemetryConstants.CUSTOMER_SEARCH_RESULTS, "add_existing_customer", {
                "result_count": String(searchData.length)
            })
        }
    }, [isSuccessGetCustomersListData]);

    useEffect(() => {
        if (!isPostAddCustomer) {
            if (successPostAddCustomer) {
                if (showFamilyResult(postAddCustomerResponse)) return;
                logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_SUCCEEDED, 'Add Customer', {
                    customerCount: selectedData.length,
                    totalDuration: flowElapsedSeconds()
                });
                logFlowEvent(TelemetryConstants.FLOW_COMPLETED, 'Add Customer', {
                    totalDuration: flowElapsedSeconds()
                });
                endFlow();
                setSuccessData({
                    customer_name: selectedData[0]?.accountName,
                    country: selectedData[0]?.country,
                    impacted_revenue: estimatedValue,
                    skpIdPost: postAddCustomerResponse?.id
                });
                if (onSuccessHandler) {
                    onSuccessHandler(postAddCustomerResponse, addedCustomerImpacts);
                    return;
                } else {
                    setRequestProcessing(false);
                    setDisplayScreen('successPopUp');
                    AppQueryClient.invalidateQueries('getRequestById');
                }

                globalSelectedRequest.unifiedTrackingId = postAddCustomerResponse?.id;
                setSelectedRequest(globalSelectedRequest);
            } else if (errorPostAddCustomer) {
                logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_FAILED, 'Add Customer', {
                    requestType: selectedRequest.requestType
                });
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        }
    }, [successPostAddCustomer, errorPostAddCustomer, isPostAddCustomer, postAddCustomerResponse, showFamilyResult]);

    useEffect(() => {
        if (!isPostAddCustomerRR) {
            if (successPostAddCustomerRR) {
                if (showFamilyResult(postAddCustomerResponseRR)) return;
                logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_SUCCEEDED, 'Add Customer', {
                    customerCount: selectedData.length,
                    totalDuration: flowElapsedSeconds()
                });
                logFlowEvent(TelemetryConstants.FLOW_COMPLETED, 'Add Customer', {
                    totalDuration: flowElapsedSeconds()
                });
                endFlow();
                setSuccessData({
                    customer_name: selectedData[0]?.accountName,
                    country: selectedData[0]?.country,
                    impacted_revenue: estimatedValue,
                    skpIdPost: postAddCustomerResponseRR?.id
                });
                if (onSuccessHandler) {
                    onSuccessHandler(postAddCustomerResponseRR, addedCustomerImpacts);
                    return;
                } else {
                    setRequestProcessing(false);
                    setDisplayScreen('successPopUp');
                }
                globalSelectedRequest.unifiedTrackingId = postAddCustomerResponseRR?.id;
                setSelectedRequest(globalSelectedRequest);
            } else if (errorPostAddCustomerRR) {
                logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_FAILED, 'Add Customer', {
                    requestType: selectedRequest.requestType
                });
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        }
    }, [successPostAddCustomerRR, errorPostAddCustomerRR, isPostAddCustomerRR, postAddCustomerResponseRR, showFamilyResult]);

    useEffect(() => {
        if (!isPostAddCustomerTR) {
            if (successPostAddCustomerTR) {
                if (showFamilyResult(postAddCustomerResponseTR)) return;
                logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_SUCCEEDED, 'Add Customer', {
                    customerCount: selectedData.length,
                    totalDuration: flowElapsedSeconds()
                });
                logFlowEvent(TelemetryConstants.FLOW_COMPLETED, 'Add Customer', {
                    totalDuration: flowElapsedSeconds()
                });
                endFlow();
                setSuccessData({
                    customer_name: selectedData[0]?.accountName,
                    country: selectedData[0]?.country,
                    impacted_revenue: estimatedValue,
                    skpIdPost: postAddCustomerResponseTR?.id
                });
                if (onSuccessHandler) {
                    onSuccessHandler(postAddCustomerResponseTR, addedCustomerImpacts);
                    return;
                } else {
                    setRequestProcessing(false);
                    setDisplayScreen('successPopUp');
                }
                globalSelectedRequest.unifiedTrackingId = postAddCustomerResponseTR?.id;
                setSelectedRequest(globalSelectedRequest);
            } else if (errorPostAddCustomerTR) {
                logFlowEvent(TelemetryConstants.ADD_CUSTOMER_SUBMIT_FAILED, 'Add Customer', {
                    requestType: selectedRequest.requestType
                });
                setRequestProcessing(false);
                setDisplayScreen('errorPopUp');
            }
        }
    }, [successPostAddCustomerTR, errorPostAddCustomerTR, isPostAddCustomerTR, postAddCustomerResponseTR, showFamilyResult]);

    const sortData = (data: MsxSuggestDocument[], selectedAccount: string) => {
        const selectedData: MsxSuggestDocument[] = [];
        const otherData: MsxSuggestDocument[] = [];

        for (let i = 0; i < data.length; i++) {
            if (data[i].accountNumber === selectedAccount) {
                selectedData.push(data[i]);
            } else {
                otherData.push(data[i]);
            }
        }
        return selectedData.concat(otherData);
    };

    if (familyResult && displayScreen === 'familyResults') {
        return <CustomerFamilyResult result={familyResult} />;
    }

    return (
        <>
            <div>
                {displayScreen === 'searchCust' && (
                    <div className="addImpact-container">
                        <div className={`close-model `}>
                            <IconButton
                                role="button"
                                aria-label="close popup"
                                iconProps={cancelIcon}
                                ariaLabel="Close popup modal"
                                tabIndex={0}
                                onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, dismissHandler)}
                                onClick={dismissHandler}
                                data-testid="icon-button1"
                            />
                        </div>
                        <div className="modal-heading">
                            <span>
                                <Trans>Add customer</Trans>
                            </span>
                            {(selectedRequest?.unifiedTrackingId || selectedRequest?.summary) && (
                                <div className="drawer-subtitle">
                                    {selectedRequest?.unifiedTrackingId}
                                    {selectedRequest?.summary ? ` · ${selectedRequest.summary}` : ''}
                                </div>
                            )}
                        </div>
                        <div className="modal-body">
                            <div className="body-main-container ">
                                <div className="form-control auto-suggest-container">
                                    <SearchMSXGrouped
                                        onOpportunitySelect={handleGroupedOpportunitySelect}
                                        onCustomerSelect={handleGroupedCustomerSelect}
                                        onAddNewCustomer={handleGroupedAddNewCustomer}
                                        getSpeechToTextToken={() => undefined}
                                    />

                                </div>
                            </div>

                            {selectedData.length > 0 && (
                                <div className="added-section">
                                    <Text className="added-label">
                                        <Trans>Selected customers and opportunities</Trans>
                                    </Text>
                                    <div className="cards-grid" role="list">
                                        {selectedData.map((item, index) => (
                                            <CustomerCard
                                                key={`${item.accountName}-${index}`}
                                                impact={mapSelectedToImpact(item)}
                                                onRemove={() => handleRemoveSelected(index)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            )}

                            {searchedCustomer.length > 1 && (
                                <div className="add-heading" aria-label="Search Results" tabIndex={0}>
                                    <div className="search-count-container">Search Results ({searchedCustomer.length})</div>
                                </div>
                            )}

                            <div className={`body-result-container ${displayScreen === 'searchCust' ? 'add-height' : ''}`}>
                                {toggleTable && !matchFound && searchedMSX === '' && (
                                    <span className="no-results-found">
                                        <Trans>Sorry,we couldn't find any results</Trans>
                                    </span>
                                )}

                                {isLoadingCustomerList && (
                                    <div className="m-t-50">
                                        <Spinner label="Search results are loading. Please wait..." size={SpinnerSize.large} />
                                    </div>
                                )}
                                {noDetailsFound && (
                                    <div tabIndex={0} aria-label="No details found">
                                        No details found
                                    </div>
                                )}
                                {searchedCustomer && searchedCustomer.length > 0 && (
                                    <>
                                        {searchedCustomer.length > 0 && (
                                            <>
                                                <div className="addCustomer-table-container ">
                                                    <DataTable<MsxSuggestDocument>
                                                        columns={searchedColumns(selectedAccountId)}
                                                        data={sortData(searchedCustomer, selectedAccountId)}
                                                        sortIcon={<ChevronDownIcon />}
                                                        selectableRows
                                                        onSelectedRowsChange={handleSelect}
                                                        selectableRowDisabled={rowDisabledCriteria}
                                                        clearSelectedRows={toggledClearRows}
                                                        selectableRowsNoSelectAll
                                                    />
                                                </div>

                                                <div className="btn-link-container">
                                                    <HLink
                                                        tabIndex={0}
                                                        onClick={() => {
                                                            setIsAddNewDetails(true);
                                                            setDisplayScreen(StringConstants.CAMELCASE_ADD_NEW_DETAILS);
                                                            setManualData(true);
                                                        }}
                                                        onKeyPress={(e: React.KeyboardEvent<HTMLAnchorElement>) =>
                                                            keyPress(e, () =>
                                                                setDisplayScreen(StringConstants.CAMELCASE_ADD_NEW_DETAILS)
                                                            )
                                                        }
                                                        className="btn-link link-right">
                                                        <Trans>Can't Find Customer</Trans>
                                                    </HLink>
                                                </div>
                                            </>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="drawer-footer">
                            <DefaultButton
                                tabIndex={0}
                                text="Cancel"
                                data-testid="add-customer-cancel-button"
                                onClick={dismissHandler}
                                onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, dismissHandler)}
                            />
                            <PrimaryButton
                                tabIndex={0}
                                text="Next"
                                data-testid="add-customer-next-button"
                                disabled={selectedData.length === 0}
                                onClick={() => setDisplayScreen('addMultiDetails')}
                                onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) =>
                                    keyPress(e, () => setDisplayScreen('addMultiDetails'))
                                }
                            />
                        </div>
                    </div>
                )}

                {displayScreen === 'addDetails' && !isPostAddCustomer && (
                    <AddNewDetails
                        isEdit={!!initialCustomer}
                        invalidEditCustomerName={!!initialCustomer && selectedData[0]?.accountName !== seededEdit.current?.accountName && !selectedData[0]?.accountName?.trim()}
                        selectedRequest={selectedRequest}
                        onDismiss={dismissHandler}
                        setDisplayScreen={setDisplayScreen}
                        selectedData={selectedData}
                        handleChange={handleChange}
                        handleChanges={handleChanges}
                        handleAddCustomer={handleAddCustomer}
                        customerHelperText={customerHelperText}
                        newCountryHelperText={newCountryHelperText}
                        errorCustomerName={errorCustomerName}
                        errorCountry={errorCountry}
                        errorEstimatedValue={errorEstimatedValue}
                        errorTotalDeviceCount={errorTotalDeviceCount}
                        multiFormError={multiFormError}
                        type="AddDetails"
                        cssNumber={cssNumber}
                        setCssNumber={setCssNumber}
                        cssErrorText={cssNumberText}
                        setErrorText={setCssNumberText}
                        countryList={countryList}
                    />
                )}

                {displayScreen === 'addMultiDetails' && !isPostAddCustomer && (
                    <AddMultiDetails
                        isEdit={!!initialCustomer}
                        retrySynchronization={editPending.current}
                        selectedRequest={selectedRequest}
                        onDismiss={dismissHandler}
                        setDisplayScreen={setDisplayScreen}
                        selectedData={selectedData}
                        handleMultiChange={handleMultiChange}
                        handleMultiChanges={handleMultiChanges}
                        multiFormError={multiFormError}
                        handleAddCustomer={handleAddCustomer}
                        cssNumber={cssNumber}
                        setCssNumber={setCssNumber}
                        cssErrorText={cssNumberText}
                        setErrorText={setCssNumberText}
                    />
                )}

                {displayScreen === StringConstants.CAMELCASE_ADD_NEW_DETAILS && (
                    <AddNewDetails
                        isEdit={!!initialCustomer}
                        invalidEditCustomerName={!!initialCustomer && selectedData[0]?.accountName !== seededEdit.current?.accountName && !selectedData[0]?.accountName?.trim()}
                        retrySynchronization={editPending.current}
                        selectedRequest={selectedRequest}
                        onDismiss={dismissHandler}
                        setDisplayScreen={setDisplayScreen}
                        selectedData={selectedData}
                        handleChange={handleChange}
                        handleChanges={handleChanges}
                        handleAddCustomer={handleAddCustomer}
                        customerHelperText={customerHelperText}
                        newCountryHelperText={newCountryHelperText}
                        errorCustomerName={errorCustomerName}
                        errorCountry={errorCountry}
                        errorEstimatedValue={errorEstimatedValue}
                        errorTotalDeviceCount={errorTotalDeviceCount}
                        multiFormError={multiFormError}
                        type="AddNewDetails"
                        cssNumber={cssNumber}
                        setCssNumber={setCssNumber}
                        cssErrorText={cssNumberText}
                        setErrorText={setCssNumberText}
                        countryList={countryList}
                    />
                )}

                {initialCustomer && editError && (
                    <MessageBar messageBarType={MessageBarType.error} role="alert">{t(editError)}</MessageBar>
                )}

                {displayScreen === 'successPopUp' && (
                    <SuccessPopup
                        onDismiss={dismissHandler}
                        setDisplayScreen={setDisplayScreen}
                        successData={successData}
                        setSearchField={setSearchField}
                        setMatchFound={setMatchFound}
                        setToggleTable={setToggleTable}
                        setSearchedCustomer={setSearchedCustomer}
                        setSelectedData={() => setSelectedData([])}
                    />
                )}

                {displayScreen === 'errorPopUp' && (
                    <div className="selected-customer-container">
                        <div className={`close-model close-primary `}>
                            <IconButton
                                role="button"
                                aria-label="close popup"
                                iconProps={cancelIcon}
                                ariaLabel="Close popup modal"
                                tabIndex={0}
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    dismissHandler();
                                }}
                                onKeyPress={(e: React.KeyboardEvent<HTMLButtonElement>) => keyPress(e, dismissHandler)}
                            />
                        </div>
                        <div className="modal-body success-body">
                            <Text className="success-title">
                                <Trans>Something went wrong.</Trans>
                            </Text>
                            <Text className="success-title error-link">
                                <Link to="/submit-feedback">
                                    <Trans>Please tell us about it</Trans>
                                </Link>
                            </Text>
                        </div>
                    </div>
                )}
                {displayScreen === 'updateProducts' && (
                    <AddProduct
                        setCssNumberText={setCssNumberText}
                        addOrUpdate={StringConstants.ADD}
                        selectedRequest={globalSelectedRequest}
                        onDismiss={dismissHandler}
                        setDisplayScreen={setDisplayScreen}
                        addedDevices={addedDevices}
                        setAddedDevices={setAddedDevices}
                        handleAddProduct={() => {
                            setRequestProcessing(true);
                            if (submitAddCustomer()) {
                                setDisplayScreen('');
                            }
                        }}
                    />
                )}
                {requestProcessing && (
                    <Spinner
                        className="p-t-50 p-b-50"
                        size={SpinnerSize.large}
                        label="Please wait, while we are processing your request"
                    />
                )}
            </div>
        </>
    );
};

export default AddCustomer;
